import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { Storage } from '../services/storage';
import type { UserProfileRequest, UserProfileResponse } from '../models';

/**
 * UserProfileApi — HTTP calls for the merchant user profile.
 *
 * Single endpoint: POST /api/gozem_money/user_profile
 *
 * Returns the merchant `profile` object whose `status` field is the
 * authoritative source for account suspension.
 *
 * Auth credentials are read automatically from localStorage via Storage service.
 */
@Injectable({
  providedIn: 'root',
})
export class UserProfileApi {
  private readonly http = inject(HttpClient);
  private readonly storage = inject(Storage);

  /** Fetch the merchant user profile. */
  getUserProfile(): Observable<UserProfileResponse> {
    const userData = this.storage.getUserData();
    if (!userData) {
      return throwError(() => new Error('User data not found in storage'));
    }

    const payload: UserProfileRequest = {
      merchant_id: userData.merchantId,
      user_type: 'merchant',
      device_type: 'web',
      token: userData.token,
    };

    return this.http
      .post<UserProfileResponse>(`${environment.apiUrl}/api/gozem_money/user_profile`, payload)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
